(function () {
  if (window.__lpHome) return;
  window.__lpHome = true;
  document.documentElement.classList.add('lp-js');

  function reveal(root) {
    var els = (root || document).querySelectorAll('.lp-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reveal(); });
  else reveal();

  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
